import { Module4Service } from '../../../services/module4Service';
import { shouldThrottleRequest } from './throttleUtils';

/**
 * Fetches batch status by workflow ID with throttling protection
 * @param workflowId - The workflow ID to query
 * @param clientId - Optional client ID
 * @param lastStatusData - Reference to last known status data
 */
export async function fetchBatchStatus(workflowId: number, clientId?: number, lastStatusData?: any) {
  const requestKey = `batchStatus-${workflowId}-${clientId || 'none'}`;
  
  // Check for throttling and get cached data if available
  if (shouldThrottleRequest(requestKey)) {
    // Return the last known data or throw a throttled error
    if (lastStatusData) return lastStatusData;
    
    // If no data available, wait for the minimum interval then allow the request
    await new Promise(resolve => setTimeout(resolve, 5000));
  }
  
  // Perform the actual request
  return Module4Service.getInstance().getBatchStatusByWorkflowDb(workflowId, clientId);
}

/**
 * Fetches module status with throttling protection
 * @param moduleId - The module ID to query
 * @param lastStatusData - Reference to last known status data
 */
export async function fetchModuleStatus(moduleId: number, lastStatusData?: any) {
  const requestKey = `moduleStatus-${moduleId}`;
  
  // Check for throttling and get cached data if available
  if (shouldThrottleRequest(requestKey)) {
    // Return the last known data or throw a throttled error
    if (lastStatusData) return lastStatusData;
    
    // If no data available, wait for the minimum interval then allow the request
    await new Promise(resolve => setTimeout(resolve, 5000));
  }
  
  // Perform the actual request
  return Module4Service.getInstance().getBatchStatusDb(moduleId);
}
